import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  getBusinessReports,
  getReportsCCAndCountry,
  getReportsCCAndCountryLocal,
  getSelectedBusinessReport
} from '../../selector';
import * as actions from '../../actions';

import DataSource from './DataSource';

const mapStateToProps = state => {
  const { fetchingReports } = state.reports;
  const businessReports = getBusinessReports(state);
  const businessReport = state.reports.businessReport;
  const { costcenter, country } = getReportsCCAndCountryLocal(state);
  const { dynamicFilters } = state.reports;

  return {
    country,
    costcenter,
    fetchingReports,
    businessReports,
    businessReport,
    dynamicFilters
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(DataSource);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/DataSource/DateSourceContainer.js